<template>
    <multiselect
        v-model="paymentsArray"
        :options="paymentMethodsOptions"
        track-by="key"
        label="value"
        :multiple="true"
        :allowEmpty="this.allowEmpty"
        placeholder="Métodos de Pago"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {paymentMethods} from '@/constants/payment-constants';

    export default {
        name: "PaymentMethodMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            allowEmpty: Boolean,
            value: Array // ['BANK', 'RECEIPT', 'COLLECTOR']
        },
        data: function () {
            return {
                paymentsArray: this.evaluateValue(this.value)
            }
        },
        computed: {
            paymentMethodsOptions() {
                let options = paymentMethods.slice(0);
                options.unshift({
                    key: 'ALL',
                    value: 'Todas'
                });
                return options;
            }
        },
        methods: {
            evaluateValue(value) {
                if (Array.isArray(value) && !!value.length) {
                    let array = [];
                    value.forEach((paymentMethod) => {
                        if (
                            !!paymentMethod
                            && !!this.findOptionByKey(paymentMethod)
                        ) {
                            array.push(this.findOptionByKey(paymentMethod));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },
            findOptionByKey(key) {
                return paymentMethods.find(method => (method.key === key));
            },
            selectAllOptions() {
                let index = this.paymentsArray.findIndex(payment => (payment.key === 'ALL'));
                if (index) {
                    this.paymentsArray.splice(index, 1);
                }

                this.paymentsArray = paymentMethods.slice(0);
            },
            notifyChange(selected) {
                if (!!selected.find(payment => (payment.key === 'ALL'))) {
                    this.selectAllOptions();
                }
                this.$emit('input', this.paymentsArray.map(paymentMethod => (paymentMethod.key)));
            }
        },
        watch: {
            value: function () {
                this.paymentsArray = this.evaluateValue(this.value)
            }
        }
    }
</script>

<style scoped>

</style>
